<template>
    <div class="jobManager">
        <el-breadcrumb class="Breadcrumb" separator="/">
            <el-breadcrumb-item>发布管理</el-breadcrumb-item>
        </el-breadcrumb>
        <el-divider></el-divider>
        <div class="search">
            <el-row :gutter="5">
                <el-col :span="3">
                    <el-input v-model="search.companyNameOrJobTitle" placeholder="请输入公司名称或工作名称"></el-input>
                </el-col>
                <el-col :span="4" :offset="1">
                    <el-select v-model="search.jobType" filterable clearable placeholder="请选择工作类型">
                        <el-option key="1" label="短期" value="1"></el-option>
                        <el-option key="2" label="兼职" value="2"></el-option>
                        <el-option key="3" label="实习" value="3"></el-option>
                        <el-option key="4" label="全职" value="4"></el-option>
                        <el-option key="5" label="出国劳务" value="5"></el-option>
                    </el-select>
                </el-col>
                <el-col :span="4">
                    <el-cascader placeholder="请选择地域" :model="search.zoneFullDdicId" clearable :options="selectZone"
                        filterable @change="selectZoneChange"></el-cascader>
                </el-col>
                <el-col :span="3">
                    <el-select v-model="search.salaryDdicId" filterable clearable placeholder="请选择薪资要求"
                        style="width: 100%;">
                        <el-option v-for="item in selectSalary" :key="item.value" :label="item.label"
                            :value="parseInt(item.value)">
                        </el-option>
                    </el-select>
                </el-col>
                <el-col :span="4" :offset="1">
                    <el-select v-model="search.auditStatus" filterable clearable placeholder="审核状态">
                        <el-option key="0" label="未审核" value="0"></el-option>
                        <el-option key="1" label="审核通过" value="1"></el-option>
                        <el-option key="2" label="审核不通过" value="2"></el-option>
                    </el-select>
                </el-col>
                <el-col :span="4">
                    <el-button type="primary" @click="getListFun(1)" icon="el-icon-search">查询</el-button>
                    <el-button type="primary" @click="openAdd()" icon="el-icon-plus">添加</el-button>
                </el-col>
            </el-row>

        </div>
        <el-divider></el-divider>

        <div class="table">
            <el-table :data="tableData" stripe style="width: 100%">
                <el-table-column prop="seq" label="排序序列(倒叙)">
                </el-table-column>
                <el-table-column prop="jobTitle" label="工作标题">
                </el-table-column>
                <el-table-column prop="jobType" label="工作类型">
                </el-table-column>
                <el-table-column prop="companyName" label="公司名称">
                </el-table-column>
                <el-table-column prop="jobDdicName" label="工种">
                </el-table-column>
                <el-table-column prop="zoneDdicName" label="工作地区">
                </el-table-column>
                <el-table-column prop="jobAdd" label="详细地址">
                </el-table-column>
                <el-table-column prop="educationDdicName" label="学历">
                </el-table-column>
                <el-table-column prop="experienceDdicName" label="工作经验">
                </el-table-column>
                <el-table-column prop="salaryDdicName" label="工资">
                </el-table-column>
                <el-table-column prop="check" label="查看次数">
                </el-table-column>
                <el-table-column prop="sendNum" label="投递次数">
                </el-table-column>
                <el-table-column prop="auditStatusStr" label="审核状态">
                </el-table-column>
                <el-table-column prop="isUsed" label="发布状态">
                </el-table-column>
                <el-table-column prop="id" fixed="right" label="操作" width="200">
                    <template slot-scope="scope">
                        <el-button v-if="scope.row.auditStatusStr == '未审核'" @click="openAudit(scope.row.id)" type="text"
                            icon="el-icon-edit" size="small">审核</el-button>
                        <el-button @click="topFun(scope.row.id)" type="text" icon="el-icon-upload2"
                            size="small">置顶</el-button>
                        <el-button @click="upFun(scope.row.id)" type="text" icon="el-icon-caret-top"
                            size="small">上移</el-button>
                        <el-button @click="downFun(scope.row.id)" type="text" icon="el-icon-caret-bottom"
                            size="small">下移</el-button>
                            <el-button @click="bottomFun(scope.row.id)" type="text" icon="el-icon-download"
                            size="small">置底</el-button>
                            <el-button @click="deleteFun(scope.row.id)" type="text" icon="el-icon-delete"
                            size="small">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!--分页-->
        <div class="pagination">
            <el-pagination background @size-change="changSizeFun" @current-change="changpageFun"
                :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
                :total="totalNum">
            </el-pagination>
        </div>
        <!-- 审核弹窗-->
        <el-dialog title="工作审核" :visible.sync="auditPop" class="customClass" width="30%">
            <el-select v-model="audit.auditStatus" filterable clearable placeholder="审核状态">
                <el-option key="1" label="审核通过" value="1"></el-option>
                <el-option key="2" label="审核不通过" value="2"></el-option>
            </el-select>
            <div slot="footer" class="dialog-footer">
                <el-button @click="auditPop = false">取 消</el-button>
                <el-button type="primary" @click="addAuditFun()">确 定</el-button>
            </div>
        </el-dialog>
        <!-- 添加弹窗-->
        <el-dialog :title="jobTitle" :visible.sync="jobPop" class="customClass" width="35%">
            <el-form :model="jobData" ref="ruleForm" label-width="80px">
                <el-form-item label="工作标题" prop="jobTitle">
                    <el-input placeholder="请输入工作标题" v-model="jobData.jobTitle"></el-input>
                </el-form-item>
                <el-form-item label="工作类型" prop="jobType">
                    <el-select v-model="jobData.jobType" filterable clearable placeholder="请选择工作类型" style="width: 100%;">
                        <el-option key="1" label="短期" :value="parseInt(1)"></el-option>
                        <el-option key="2" label="兼职" :value="parseInt(2)"></el-option>
                        <el-option key="3" label="实习" :value="parseInt(3)"></el-option>
                        <el-option key="4" label="全职" :value="parseInt(4)"></el-option>
                        <el-option key="5" label="出国劳务" :value="parseInt(5)"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="工作区域" prop="zoneFullDdicId">
                    <el-cascader placeholder="请选择工作区域" :model="jobData.zoneFullDdicId" clearable :options="selectZone"
                        filterable @change="selectJobDataZoneChange" style="width: 100%;"></el-cascader>
                </el-form-item>
                <el-form-item label="工种" prop="jobFullDdic">
                    <el-cascader placeholder="请选择工种" :model="jobData.jobFullDdic" clearable :options="selectJob" filterable
                        @change="selectJobDataJobChange" style="width: 100%;"></el-cascader>
                </el-form-item>
                <el-form-item label="学历要求" prop="educationDdicId">
                    <el-select v-model="jobData.educationDdicId" filterable clearable placeholder="请选择学历要求"
                        style="width: 100%;">
                        <el-option v-for="item in selectEducation" :key="item.value" :label="item.label"
                            :value="parseInt(item.value)">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="经验要求" prop="experienceDdicId">
                    <el-select v-model="jobData.experienceDdicId" filterable clearable placeholder="请选择经验要求"
                        style="width: 100%;">
                        <el-option v-for="item in selectExperience" :key="item.value" :label="item.label"
                            :value="parseInt(item.value)">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="岗位薪资" prop="salaryDdicId">
                    <el-select v-model="jobData.salaryDdicId" filterable clearable placeholder="请选择岗位薪资"
                        style="width: 100%;">
                        <el-option v-for="item in selectSalary" :key="item.value" :label="item.label"
                            :value="parseInt(item.value)">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="工作地址" prop="jobAdd">
                    <el-input placeholder="请输入工作地址" v-model="jobData.jobAdd"></el-input>
                </el-form-item>
                <el-form-item label="工作标签" prop="jobTag">
                    <el-input placeholder="请输入工作标签,用逗号分隔" v-model="jobData.jobTag"></el-input>
                </el-form-item>
                <el-form-item label="工作描述">
                    <el-input type="textarea" :rows="5" placeholder="请输入工作描述" v-model="jobData.jobDescribe">
                    </el-input>
                </el-form-item>
                <el-form-item label="联系人(选填)" prop="linkman">
                    <el-input placeholder="请输入联系人" v-model="jobData.linkman"></el-input>
                </el-form-item>
                <el-form-item label="联系电话(选填)" prop="mobile">
                    <el-input placeholder="联系电话" v-model="jobData.mobile"></el-input>
                </el-form-item>
                <el-form-item label="公司" prop="companyId">
                    <el-select v-model="jobData.companyId" filterable clearable placeholder="请选择公司" style="width: 100%;">
                        <el-option v-for="item in pop.selectCompany" :key="item.id" :label="item.name" :value="parseInt(item.id)">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="jobPop = false">取 消</el-button>
                <el-button type="primary" @click="addJobFun()">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>

export default {
    data() {
        return {
            //学历
            selectEducation: [],
            //工作年限
            selectExperience: [],
            //工资
            selectSalary: [],
            //地域
            selectZone: [],
            //工作类型
            selectJob: [],
            search: {
                //公司名称或工作名称
                companyNameOrJobTitle: '',
                //地域
                zoneFullDdicId: '',
                //工作类型
                jobType: '',
                //薪资范围
                salaryDdicId: '',
                //审核状态
                auditStatus: '',
            },
            pageSize: 10,
            pageNum: 1,
            tableData: [],
            totalNum: 0,
            audit: {
                id: '',
                auditStatus: '',
            },
            auditPop: false,
            jobPop: false,
            jobTitle: '',
            pop: {
                selectCompany: [],
            },
            jobData: {
                jobTitle: '', //工作标题
                jobDescribe: '',//描述
                jobType: '',//工作类型 1短期 2兼职 3实习 4全职 5 出国劳务
                jobDdic: '',//职位类型
                jobFullDdic: '',//职位类型全路径
                zoneDdicId: '',//所属地区 字典ID
                zoneFullDdicId: '',//全路径所属地区
                jobAdd: '',//工作地址
                jobTag: '',//工作标签
                linkman: '',//联系人
                mobile: '',//联系电话
                educationDdicId: '',//学历要求
                experienceDdicId: '',//经验要求
                salaryDdicId: '',//岗位薪资
                companyId: '', //公司ID
            }
        }
    },
    mounted() {
        this.getSelect();
        this.getList();
    },
    methods: {
        selectZoneChange(value) {
            this.search.zoneFullDdicId = value;
        },
        selectsalaryChange(value) {
            this.search.salaryDdicId = value;
        },
        selectJobDataZoneChange(value) {
            this.jobData.zoneDdicId = value[value.length-1];
            this.jobData.zoneFullDdicId = value;
        },
        selectJobDataJobChange(value) {
            this.jobData.jobDdic = value[value.length-1];
            this.jobData.jobFullDdic = value;
        },
        getSelect() {
            let data = {}
            //学历
            this.$get(api + "/jobManager/getSelectEducation", data).then(response => {
                let res = response.data;
                if (res.code == 0) {
                    this.selectEducation = res.data;
                }
            })
            //工作年限
            this.$get(api + "/jobManager/getSelectExperience", data).then(response => {
                let res = response.data;
                if (res.code == 0) {
                    this.selectExperience = res.data;
                }
            })
            //工资
            this.$get(api + "/jobManager/getSelectSalary", data).then(response => {
                let res = response.data;
                if (res.code == 0) {
                    this.selectSalary = res.data;
                }
            })
            //地域
            this.$get(api + "/jobManager/getSelectZone", data).then(response => {
                let res = response.data;
                if (res.code == 0) {
                    this.selectZone = res.data;
                }
            })
            //工作类型
            this.$get(api + "/jobManager/getSelectJob", data).then(response => {
                let res = response.data;
                if (res.code == 0) {
                    this.selectJob = res.data;
                }
            })
        },
        openAudit(val) {
            this.audit.id = val;
            this.audit.auditStatus = '';
            this.auditPop = true;
        },
        addAuditFun() {
            let data = this.audit
            this.$post(api + "/jobManager/auditJob", data).then(response => {
                let res = response.data;
                if (res.code == 0) {
                    if (res.code == 0) {
                        this.$message({
                            type: 'success',
                            message: '审核完成'
                        });
                        this.auditPop = false
                        this.getList();
                    } else {
                        this.$message.error(res.desc);
                    }
                }
            })
        },
        openAdd() {
            this.jobTitle = '添加新工作'
            this.jobData = {
                id:'',
                jobTitle: '', //工作标题
                jobDescribe: '',//描述
                jobType: '',//工作类型 1短期 2兼职 3实习 4全职 5 出国劳务
                jobDdic: '',//职位类型
                jobFullDdic: '',//职位类型全路径
                zoneDdicId: '',//所属地区 字典ID
                zoneFullDdicId: '',//全路径所属地区
                jobAdd: '',//工作地址
                jobTag: '',//工作标签
                linkman: '',//联系人
                mobile: '',//联系电话
                educationDdicId: '',//学历要求
                experienceDdicId: '',//经验要求
                salaryDdicId: '',//岗位薪资
                companyId: '', //公司ID
            },
                this.pop = {
                    selectCompany: [],
                }
            this.getSelectCompany();
            this.jobPop = true;
        },
        getSelectCompany() {
            let data = {}
            //学历
            this.$get(api + "/jobManager/getSelectCompany", data).then(response => {
                let res = response.data;
                if (res.code == 0) {
                    this.pop.selectCompany = res.data;
                }
            })
        },
        addJobFun(){
            let data = {
                jobTitle: this.jobData.jobTitle, //工作标题
                jobDescribe: this.jobData.jobDescribe,//描述
                jobType: this.jobData.jobType,//工作类型 1短期 2兼职 3实习 4全职 5 出国劳务
                jobDdic: this.jobData.jobFullDdic[this.jobData.jobFullDdic.length-1],//职位类型
                jobFullDdic: this.jobData.jobFullDdic.toString(),//职位类型全路径
                zoneDdicId: this.jobData.zoneFullDdicId[this.jobData.zoneFullDdicId.length-1],//所属地区 字典ID
                zoneFullDdicId: this.jobData.zoneFullDdicId.toString(),//全路径所属地区
                jobAdd: this.jobData.jobAdd,//工作地址
                jobTag: this.jobData.jobTag,//工作标签
                linkman: this.jobData.linkman,//联系人
                mobile: this.jobData.mobile,//联系电话
                educationDdicId: this.jobData.educationDdicId,//学历要求
                experienceDdicId: this.jobData.experienceDdicId,//经验要求
                salaryDdicId: this.jobData.salaryDdicId,//岗位薪资
                companyId: this.jobData.companyId, //公司ID
            }
            this.$post(api + "/jobManager/addJob", data).then(response => {
                let res = response.data;
                if (res.code == 0) {
                    this.$message({
                        type: 'success',
                        message: '添加成功!'
                    })
                    this.jobPop = false;
                    this.getListFun(1);
                } else {
                    this.$message.error(res.desc);
                }
            })
        },
        deleteFun(val){
            this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let data = {}
                this.$post(api + "/jobManager/delete/" + val, data).then(response => {
                    let res = response.data;
                    if (res.code == 0) {
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                        this.getListFun(1);
                    } else {
                        this.$message.error(res.desc);
                    }
                })
            }).catch(() => {

            });
        },
        getList() {
            let data = {
                companyNameOrJobTitle: this.search.companyNameOrJobTitle,
                zoneFullDdicId: this.search.zoneFullDdicId.toString(),
                jobType: this.search.jobType,
                salaryDdicId: this.search.salaryDdicId,
                auditStatus: this.search.auditStatus,
                pageSize: this.pageSize,
                pageNum: this.pageNum,
            }
            this.$get(api + "/jobManager/getList", data).then(response => {
                let res = response.data;
                if (res.code == 0) {
                    this.tableData = res.data;
                    this.totalNum = res.totalNum
                }
            })
        },
        topFun(id) {
            let url = "/jobManager/top/" + id;
            this.changePlace(url);
        },
        upFun(id) {
            let url = "/jobManager/up/" + id;
            this.changePlace(url);
        },
        downFun(id) {
            let url = "/jobManager/down/" + id;
            this.changePlace(url);
        },
        bottomFun(id) {
            let url = "/jobManager/bottom/" + id;
            this.changePlace(url);
        },
        //换位置
        changePlace(url) {
            let data = {}
            this.$post(api + url, {}).then(response => {
                let res = response.data;
                if (res.code == 0) {
                    this.getList();
                } else {
                    this.$message.error(res.desc);
                }
            })
        },

        //特定pageNum查询列表
        getListFun(val) {
            this.pageNum = val;
            this.getList();
        },

        //更换pageSize
        changSizeFun(val) {
            console.log(`每页 ${val} 条`);
            this.pageSize = val;
            this.getList();
        },
        //翻页
        changpageFun(val) {
            console.log(this.pageNum);
            this.pageNum = val;
            this.getList();
        },
    }

}
</script>


// WEBPACK FOOTER //
// src/pages/company/job/JobManager.vue